import LiveBackground, { useLiveBackground } from "../../liveBackground/LiveBackground";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { mapTypeLabel } from "../../../constant/General";
import ResultMTDay from "./ResultMTDay";
import { getDateTime } from "../../../utility/dateUtils";
import ResultMTNight from "./ResultMTNight";
import Welcome from "../Welcome";
import LayoutWrapper from "./LayoutWrapper";
import { drawingV2 } from "../../../constant/initDrawing";



const Live2MTWrapper = ({ config, socket }) => {
    const { type, subFixType = "" } = config;
    const location = useLocation();
    const navigate = useNavigate();
    const backgroundType = useLiveBackground();
    const [result, setResult] = useState(drawingV2);
    const subTypes = subFixType ? `${type}s_${subFixType}_result` : `${type}s_result`


    useEffect(() => {
        socket.on(subTypes, (draw) => {
            setResult(draw);
        });

        return () => {
            socket.off(subTypes);
        }
    }, [socket, type, subFixType, subTypes]);

    const onStartDraw = (result) => setResult(result)

    if (result.results.length === 0) return <Welcome onStartDraw={onStartDraw} />

    const onBack = () => {
        navigate(backgroundType ? "/live-full" : location.pathname.includes("-black") ? "/black" : "/");
    };

    return <LiveBackground result={result} className="d-flex justify-content-center overflow-hidden mt-2">
        <button
            type="button"
            className="welcome-back-button"
            onClick={onBack}
        >
            Back
        </button>
        <div>
            <div className="live-draw-heading d-flex justify-content-center align-items-center mb-3 f-20 text-info">
                <span className="mr-4 fw-bold f-26">
                    {mapTypeLabel[config.type]}
                </span> {getDateTime(result?.drawAt)}
            </div>
            <LayoutWrapper>
                {result.isNight ?
                    <ResultMTNight result={result} config={config} /> :
                    <ResultMTDay result={result} config={config} />}
            </LayoutWrapper>

        </div>
    </LiveBackground>

};


export default Live2MTWrapper;
